import React, { Component } from "react";
import { Row, Col, Statistic, Card, Avatar, Alert, Divider } from "antd";
import {
  CloudDownloadOutlined,
  DeliveredProcedureOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileTextOutlined,
  UserOutlined,
  AuditOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import Axios from "../../../config/axios";
import withErrorHandler from "hoc/withErrorHandler";
import VerticalBar from "components/Chart/BarChart";

const borderColors = [
  "rgba(26, 188, 156,1.0)",
  "rgba(46, 204, 113,1.0)",
  "rgba(52, 152, 219,1.0)",
  "rgba(155, 89, 182,1.0)",
  "rgba(52, 73, 94,1.0)",
  "rgba(22, 160, 133,1.0)",
  "rgba(39, 174, 96,1.0)",
  "rgba(39, 174, 96,1.0)",
  "rgba(41, 128, 185,1.0)",
  "rgba(142, 68, 173,1.0)",
  "rgba(44, 62, 80,1.0)",
  "rgba(241, 196, 15,1.0)",
  "rgba(230, 126, 34,1.0)",
  "rgba(231, 76, 60,1.0)",
  "rgba(149, 165, 166,1.0)",
];

const backgroundColors = [
  "rgba(26, 188, 156,0.2)",
  "rgba(46, 204, 113,0.2)",
  "rgba(52, 152, 219,0.2)",
  "rgba(155, 89, 182,0.2)",
  "rgba(52, 73, 94,0.2)",
  "rgba(22, 160, 133,0.2)",
  "rgba(39, 174, 96,0.2)",
  "rgba(39, 174, 96,0.2)",
  "rgba(41, 128, 185,0.2)",
  "rgba(142, 68, 173,0.2)",
  "rgba(44, 62, 80,0.2)",
  "rgba(241, 196, 15,0.2)",
  "rgba(230, 126, 34,0.2)",
  "rgba(231, 76, 60,0.2)",
  "rgba(149, 165, 166,0.2)",
];

class Dashboard extends Component {
  state = {
    count: {
      submitted: 0,
      processed: 0,
      finished: 0,
      rejected: 0,
    },
    letterhead: 0,
    usersPerFaculty: undefined,
    servicesPerFaculty: undefined,
  };

  componentDidMount() {
    this.fetchCountData();
    this.fetchLetterhead();
  }

  fetchCountData = () => {
    if (["admin", "rb"].includes(this.props.user.info.type)) {
      Axios.get("/report/dashboard").then((response) => {
        const labels = [];
        const data = [];
        response.data.totalStudentsPerFaculty.forEach((student) => {
          labels.push(student.faculty);
          data.push(student.count);
        });

        const labels2 = [];
        const data2 = [];
        response.data.totalLetterPerFaculty.forEach((student) => {
          labels2.push(student.faculty);
          data2.push(student.count);
        });

        const usersPerFaculty = {
          labels,
          datasets: [
            {
              label: "Pengguna Per Fakultas",
              data: data,
              backgroundColor: backgroundColors,
              borderColor: borderColors,
              borderWidth: 1,
            },
          ],
        };

        const servicesPerFaculty = {
          labels: labels2,
          datasets: [
            {
              label: "Surat Per Fakultas",
              data: data2,
              backgroundColor: backgroundColors,
              borderColor: borderColors,
              borderWidth: 1,
            },
          ],
        };

        this.setState({
          count: response.data,
          usersPerFaculty,
          servicesPerFaculty,
        });
      });
    } else {
      Axios.get(
        "/report/count-data" +
          (this.props.user.info.type === "operator"
            ? "?unit_id=" + this.props.user.info.unit_id
            : "?major_id=" + this.props.user.info.unit_id)
      ).then((response) => {
        this.setState({ count: response.data });
      });
    }
  };

  fetchLetterhead = () => {
    Axios.get(
      "/letterhead" +
        (this.props.user.info.type !== "admin"
          ? "?unit_id=" + this.props.user.info.unit_id
          : "")
    ).then((response) => {
      this.setState({ letterhead: response.data.total });
    });
  };

  render() {
    return (
      <Col>
        <Row style={{ marginBottom: 10 }}>
          <Card style={{ width: "100%" }}>
            <Row>
              <Col>
                <Avatar
                  size={64}
                  src={this.props.user.user_unit.photo}
                  alt="avatar"
                  style={{ marginRight: 10 }}
                />
              </Col>
              <Col>
                <h3 style={{ margin: 0 }}>{this.props.user.name}</h3>
                <span>
                  {this.props.user.user_unit.simsdm_code} -{" "}
                  {this.props.user.identity}
                </span>
              </Col>
            </Row>
          </Card>
        </Row>
        <Alert
          message="Kop Surat"
          description={
            this.state.letterhead > 0
              ? "Kop Surat telah diset. Anda sudah bisa membuat surat balasan yang memiliki kop surat."
              : "Kop surat belum diset. Segera upload kop surat agar tidak terjadi kesalahan saat membuat surat balasan."
          }
          type={this.state.letterhead > 0 ? "success" : "warning"}
          showIcon
          style={{ marginBottom: 10 }}
        />
        <Divider />
        <Row gutter={[30, 16]}>
          <Col xs={24} sm={24} md={5}>
            <Card>
              <Statistic
                title="Totaal Pengguna"
                value={this.state.count.totalStudents}
                valueStyle={{ color: "#3498db" }}
                prefix={<UserOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={5}>
            <Card>
              <Statistic
                title="Total Layanan"
                value={this.state.count.totalServices}
                valueStyle={{ color: "#3498db" }}
                prefix={<AuditOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={5}>
            <Card>
              <Statistic
                title="Total Permohonan"
                value={
                  this.state.count.rejected +
                  this.state.count.finished +
                  this.state.count.processed +
                  this.state.count.submitted
                }
                valueStyle={{ color: "#3498db" }}
                prefix={<FileTextOutlined />}
              />
            </Card>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          <Col xs={24} sm={24} md={5}>
            <Card>
              <Statistic
                title="Permohonan Masuk"
                value={this.state.count.submitted}
                valueStyle={{ color: "#f39c12" }}
                prefix={<CloudDownloadOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={5}>
            <Card>
              <Statistic
                title="Sedang Diproses"
                value={this.state.count.processed}
                valueStyle={{ color: "#f1c40f" }}
                prefix={<DeliveredProcedureOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={5}>
            <Card>
              <Statistic
                title="Selesai Diproses"
                value={this.state.count.finished}
                valueStyle={{ color: "#16a085" }}
                prefix={<CheckCircleOutlined />}
              />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={5}>
            <Card>
              <Statistic
                title="Permohonan Ditolak"
                value={this.state.count.rejected}
                valueStyle={{ color: "#cf1322" }}
                prefix={<CloseCircleOutlined />}
              />
            </Card>
          </Col>
        </Row>
        <Divider />
        {["admin", "rb"].includes(this.props.user.info.type) ? (
          <Row gutter={[16, 16]} justify="center">
            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
              <Card>
                {this.state.usersPerFaculty ? (
                  <VerticalBar
                    title="Pengguna Per Fakultas"
                    data={this.state.usersPerFaculty}
                  />
                ) : (
                  <LoadingOutlined />
                )}
              </Card>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
              <Card>
                {this.state.servicesPerFaculty ? (
                  <VerticalBar
                    title="Surat Per Fakultas"
                    data={this.state.servicesPerFaculty}
                  />
                ) : (
                  <LoadingOutlined />
                )}
              </Card>
            </Col>
          </Row>
        ) : null}
      </Col>
    );
  }
}

export default withErrorHandler(Dashboard, Axios);
